import { useMemo } from 'react';
import { useResponsesContext } from './ResponsesContext';
import { getFilterDefinitions } from './filterUtils';
export function useGetFilterDefinitions() {
    const { columns } = useResponsesContext();
    const filters = useMemo(() => getFilterDefinitions(columns), [columns]);
    return filters;
}
